<template>
  <div>
    <modal-pago
      @recargar="recargar"
      :dataPago="dataPagoSelected"
      :listResponsables="listResponsables"
    >
    </modal-pago>
    <modal-pago-config
      @recargar="recargarConfig"
      :dataPagoConfig="dataPagoConfigSelected"
      :listCategorias="listCategoriasTodas"
      :listFormas="listFormasPago"
    >
    </modal-pago-config>
    <modal-auxiliar
      :listEquipos="listAuxiliarEquipos"
      :auxiliar="formaAuxiliar"
    ></modal-auxiliar>
    <div v-if="!USER().control_pagos" class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          Tú no estas autorizado! 🔐
        </h2>
        <p class="mb-2">
          No tienes los permisos para ver esta página. !!
        </p>
        <b-img
          fluid
          :src="require('@/assets/images/pages/not-authorized.svg')"
          alt="Pagina no autorizada"
          style="width:50%"
        />
      </div>
    </div>
    <div v-else>
      <b-card no-body>
        <div class="m-1">
          <b-row>
            <b-col md="11">
              <v-select
                :options="listCampeonatos"
                @input="recargarDatos"
                placeholder="Sel. Camp"
                :clearable="false"
                v-model="campeonatoSeleccionado"
              />
            </b-col>
            <b-col md="1">
              <b-button
                v-b-tooltip.hover.v-primary
                v-b-modal.modal-nueva-noticia
                title="Nueva Categoria Pago"
                variant="flat-primary"
                class="btn-icon"
                @click="nuevaConfig"
              >
                <feather-icon size="22" icon="PlusSquareIcon" />
              </b-button> </b-col
          ></b-row>
        </div>
      </b-card>
      <b-row>
        <b-col md="2">
          <div style="max-height:70vh;overflow:scroll">
            <b-col v-for="item in listCategorias" :key="item.id" md="12">
              <b-card class="ecommerce-card" no-body>
                <div class="item-img text-center">
                  <!-- <b-img :src="item.foto_url" class="card-img-top" /> -->
                </div>

                <b-card-body>
                  <h5>{{ item.disciplina }} {{ item.categoria }}</h5>
                  <span style="font-size:12px;"
                    >{{ item.total_equipos }} Equipos</span
                  >
                  <br />
                  <span
                    @click="openAuxiliar(item, '1')"
                    style="text-decoration:underline; font-size:12px;cursor:pointer"
                    >{{ item.total_categoria }} Jugadores</span
                  >
                  <br />
                  <span
                    @click="openAuxiliar(item, '2')"
                    style="text-decoration:underline; font-size:12px;cursor:pointer"
                    >{{ item.total_partidos_expectativa }} Partidos de
                    {{ item.total_partidos_fixture }}</span
                  >
                  <div style="margin-top:4px;font-size:11px;color:gray">
                    {{ item.valor }} {{ item.regla }}
                  </div>
                  <div
                    style="background:yellow; padding:4px; border-radius:3px;color:black;font-weight:bold;margin-top:10px"
                  >
                    {{ item.valor_aproximado }} $
                  </div>
                  <!-- <div
                  style="background:green; padding:4px; border-radius:3px;color:white;font-weight:bold;margin-top:10px"
                >
                  {{ item.valor_aproximado }} $
                </div> -->
                </b-card-body>
              </b-card>
            </b-col>
          </div>
        </b-col>
        <b-col md="10">
          <b-overlay :show="showLoading" rounded="sm">
            <b-row>
              <b-col md="7">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1 mb-1"
                  placeholder="Buscar por (descripción/valor/responbsabe)"
                />
              </b-col>
              <b-col md="4">
                <flat-pickr
                  placeholder="Filtrar x fecha"
                  class="form-control"
                  v-model="rangeDate"
                  :config="{ mode: 'range' }"
                />
              </b-col>
              <b-col md="1">
                <b-button
                  v-b-tooltip.hover.v-primary
                  v-b-modal.modal-nueva-noticia
                  title="Nuevo Pago"
                  variant="flat-primary"
                  class="btn-icon"
                  @click="crearPago"
                >
                  <feather-icon size="22" icon="PlusSquareIcon" />
                </b-button>
              </b-col>
            </b-row>
            <b-table
              ref="refInvoiceListTable"
              :fields="tableColumns"
              :items="listPagosFilter"
              primary-key="id"
              show-empty
              responsive
              small
              empty-text="No se encontraron datos"
              class="position-relative"
              style="max-height:60vh"
              :sticky-header="true"
              :no-border-collapse="true"
            >
              <template #cell(fecha)="data">
                <small class="text-muted">{{ data.item.fecha }}</small>
              </template>

              <template #cell(usuario)="data">
                <b-media vertical-align="center">
                  <span
                    class="font-weight-bold d-block text-nowrap text-capitalize"
                  >
                    {{ data.item.nombre }}
                  </span>
                </b-media>
              </template>
              <template #cell(seccion)="data">
                <small
                  class="font-weight-bold d-block text-nowrap text-capitalize"
                  >{{ data.item.tipo_dato }}</small
                >
              </template>

              <template #cell(fecha_nac)="data">
                <b-media vertical-align="center">
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.accion }}
                  </span>
                </b-media>
              </template>

              <template #cell(tipo)="data">
                <template>
                  <b-badge
                    pill
                    :variant="
                      data.item.tipo === `leve`
                        ? 'light-secondary'
                        : data.item.tipo === `moderada`
                        ? 'warning'
                        : 'danger'
                    "
                  >
                    {{ data.item.tipo }}
                  </b-badge>
                </template>
              </template>
              <!-- Column: Actions -->
              <template #cell(opc)="data">
                <div class="text-nowrap">
                  <feather-icon
                    icon="EditIcon"
                    class="cursor-pointer mx-1"
                    size="16"
                    @click="openDetallePago(data.item)"
                  />
                  <!-- <feather-icon
                icon="EyeOffIcon"
                class="cursor-pointer mx-1"
                size="16"
                @click="showLogEliminar(data.item, 'ocultar')"
              /> -->
                  <feather-icon
                    v-if="USER().rol === ROLES.SUPER"
                    icon="Trash2Icon"
                    class="cursor-pointer"
                    size="16"
                    @click="deletePago(data.item)"
                  />
                </div>
              </template>
            </b-table>
            <div style="width:100%; text-align:center">
              <b-badge pill variant="danger" style="margin-right:10px;">
                <span style="font-size:18px">Total: {{ totalPagar }} $</span>
              </b-badge>
              <b-badge pill variant="success" style="margin-right:10px;">
                <span style="font-size:18px;">Abono: {{ pagado }} $</span>
              </b-badge>
              <b-badge pill variant="warning" style="margin-right:10px;">
                <span style="font-size:18px;">Saldo: {{ saldo }} $</span>
              </b-badge>
            </div>
          </b-overlay>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
// import flatPickr from 'vue-flatpickr-component'
import {
  onMounted,
  ref,
  computed,
  watch,
  // xxx,
} from '@vue/composition-api'
import store from '@/store'
import {
  BCard,
  BCardBody,
  //   //   BFormCheckbox,
  //   //   BAlert,
  BButton,
  //   VBTooltip,
  BRow,
  BCol,
  BFormInput,
  //   // BFormGroup,
  BOverlay,
  BTable,
  //   //   BMedia,
  //   //   BAvatar,
  VBTooltip,
  BBadge,
  BImg,
  //   //   BButtonGroup,
  //   BTab,
  //   BTabs,
  //   BSpinner,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCall from '../../utils/apiCall'
import ModalPago from './ModalNewPago.vue'
import ModalPagoConfig from './ModalNewConfig.vue'
import ModalAuxiliar from './ModalAuxiliar.vue'
import { URL, USER, ROLES } from '../../utils/variables'

export default {
  components: {
    BCard,
    vSelect,
    BRow,
    BCol,
    BCardBody,
    BTable,
    BBadge,
    BFormInput,
    flatPickr,
    BOverlay,
    BButton,
    ModalPago,
    ModalAuxiliar,
    ModalPagoConfig,
    BImg,
    // BSpinner,
    // // BFormGroup,
    // // flatPickr,
    // // BButtonGroup,
    // BTabs,
    // BTab,
    // BBadge,
    // // BAvatar,
    // ItemPartido,
    // UpdateMatch,
    // ConfigurationGroup,
    // BOverlay,
    // TablaPosiciones,
    // ModalFinalizarEtapa,
    // PrintProgramacion,
    // TablaGoleadores,
  },
  directives: {
    'b-tooltip': VBTooltip,
    // Ripple,
  },
  setup() {
    const listCampeonatos = ref([])
    const listCategorias = ref([])
    const listCategoriasTodas = ref([])
    const listFormasPago = ref([])
    const listResponsables = ref([])
    const showLoading = ref(false)
    const searchQuery = ref('')
    const rangeDate = ref(null)
    const totalPagar = ref(null)
    const pagado = ref(null)
    const formaAuxiliar = ref(null)
    const listAuxiliarEquipos = ref({})
    const tableColumns = [
      { key: 'id_categoria_pago', label: '#', sortable: true },
      {
        key: 'fecha',
        label: 'fecha__',
        stickyColumn: true,
        sortable: true,
      },

      { key: 'nombre', label: 'responsable', sortable: true },
      // { key: 'rol', sortable: true },
      { key: 'observacion', label: 'Descripción', sortable: true },
      { key: 'valor', label: 'Valor', sortable: true },
      { key: 'num_comprobante', sortable: true },
      { key: 'opc' },
    ]
    const listPagos = ref([])
    const { getApi, postApi } = apiCall()
    const dataPagoSelected = ref({})
    const dataPagoConfigSelected = ref({})
    const dataPagoConfig = ref({
      valor: null,
      categoria: null,
      forma: null,
    })
    const dataPagoNew = ref({
      valor: null,
      descripcion: null,
      comprobante: null,
      fecha: null,
      id_campeonato: null,
      responsable: { value: null, label: 'Seleccione responsable' },
    })

    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })
    async function getConfigPagos(idCampeonato) {
      // showLoading.value = true
      listCategorias.value = []
      const path = `ApiConfiguration/getConfigPagos/${idCampeonato}`
      const data = await getApi(URL, path)
      listCategorias.value = data.data
      totalPagar.value = data.totalPagar
      // showLoading.value = false
    }

    function transformLisSelect(array) {
      const arraySalida = []
      array.forEach(element => {
        const obj = {
          label: `${element.nombre}`,
          value: element.id_responsable,
        }
        arraySalida.push(obj)
      })
      return arraySalida
    }
    function transformLisSelectFormas(array) {
      const arraySalida = []
      array.forEach(element => {
        const obj = {
          label: `${element.regla}`,
          value: element.id_forma_pago,
        }
        arraySalida.push(obj)
      })
      return arraySalida
    }
    function transformLisSelectCategorias(array) {
      const arraySalida = []
      array.forEach(element => {
        const obj = {
          label: `${element.disciplina} ${element.categoria}`,
          value: element.id_categoria,
        }
        arraySalida.push(obj)
      })
      return arraySalida
    }
    async function getUtilsPagos(idCampeonato) {
      // showLoading.value = true
      listCategoriasTodas.value = []
      listFormasPago.value = []
      const path = `ApiConfiguration/getUtilsPago/${idCampeonato}`
      const data = await getApi(URL, path)
      listCategoriasTodas.value = transformLisSelectCategorias(data.categorias)
      listFormasPago.value = transformLisSelectFormas(data.formas)
      // showLoading.value = false
    }
    async function getResponsables() {
      // showLoading.value = true
      listResponsables.value = []
      const path = 'ApiConfiguration/getResponsables/'
      const data = await getApi(URL, path)
      listResponsables.value = transformLisSelect(data.data)
      // console.log(listResponsables.value)
      // showLoading.value = false
    }

    function crearPago() {
      getResponsables()
      dataPagoSelected.value = { ...dataPagoNew.value }
      dataPagoSelected.value.new = true
      dataPagoSelected.value.id_campeonato = campeonatoSeleccionado.value.value
      store.commit('someVariables/UPDATE_SHOW_NEW_PAGO', true)
    }
    function openDetallePago(item) {
      dataPagoSelected.value = { ...item }
      dataPagoSelected.value.new = false
      dataPagoSelected.value.descripcion = item.observacion
      dataPagoSelected.value.comprobante = item.num_comprobante
      dataPagoSelected.value.responsable = { value: null, label: item.nombre }
      store.commit('someVariables/UPDATE_SHOW_NEW_PAGO', true)
    }
    function nuevaConfig() {
      // getResponsables()
      dataPagoConfigSelected.value = { ...dataPagoConfig.value }
      dataPagoConfigSelected.value.id_campeonato =
        campeonatoSeleccionado.value.value
      store.commit('someVariables/UPDATE_SHOW_NEW_CONFIG_PAGO', true)
    }
    function openAuxiliar(item, forma) {
      listAuxiliarEquipos.value = { ...item }
      // console.log(listAuxiliarEquipos.value)
      formaAuxiliar.value = forma
      store.commit('someVariables/UPDATE_SHOW_NEW_AUXILIAR', true)
    }
    async function getDetallePagos(idCampeonato) {
      listPagos.value = []
      showLoading.value = true
      const path = `ApiConfiguration/getListaPagos/${idCampeonato}`
      const data = await getApi(URL, path)
      listPagos.value = data.data
      pagado.value = data.pagado
      showLoading.value = false
    }
    async function deletePago(item) {
      const path = 'ApiConfiguration/deletePago/'
      const dataSend = {
        id_categoria_pago: item.id_categoria_pago,
        usuario: `${USER().nombre} ${USER().apellido}`,
      }
      const response = await postApi(URL, path, dataSend)
      if (response.flag === 'si') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'ITEM ELIMINADO exitosamente',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          }
        )
        getDetallePagos(campeonatoSeleccionado.value.value)
        // console.log('eliminado')
        // emit('eliminado', props.playerSelected)
      }
    }
    function recargar() {
      getDetallePagos(campeonatoSeleccionado.value.value)
      store.commit('someVariables/UPDATE_SHOW_NEW_PAGO', false)
    }
    function recargarDatos() {
      getConfigPagos(campeonatoSeleccionado.value.value)
      getDetallePagos(campeonatoSeleccionado.value.value)
    }
    function recargarConfig() {
      getConfigPagos(campeonatoSeleccionado.value.value)
      // getDetallePagos(campeonatoSeleccionado.value.value)
      // store.commit('someVariables/UPDATE_SHOW_NEW_PAGO', false)
    }
    const saldo = computed(() => totalPagar.value - pagado.value)

    function separaFecha() {
      // console.log(rangeDate.value)
      let auxiliar = null
      if (rangeDate.value != null) {
        const arrayFechas = rangeDate.value.split('to')
        if (arrayFechas.length >= 2) {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[1].trim(),
          }
        } else {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[0].trim(),
          }
        }
      }
      if (rangeDate.value === '') {
        // auxiliar = {
        //   valido: false,
        //   inicio: null,
        //   fin: null,
        // }
        auxiliar = null
      }
      return auxiliar
    }
    const listPagosFilter = computed(() => {
      const fecha = separaFecha()
      let listReturn = listPagos.value
      if (fecha != null && searchQuery.value === '') {
        if (fecha.valido) {
          // eslint-disable-next-line
          listReturn = listPagos.value.filter(
            log =>
              // eslint-disable-next-line
              log.fecha >= `${fecha.inicio} 00:00:00` &&
              // eslint-disable-next-line
              log.fecha <= `${fecha.fin} 23:59:59`
            // eslint-disable-next-line
          )
        }
      } else if (fecha === null && searchQuery.value !== '') {
        // eslint-disable-next-line
        listReturn = listPagos.value.filter(
          player =>
            // eslint-disable-next-line
            player.nombre
              .toLowerCase()
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.valor
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.observacion
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase())
        )
      } else if (fecha !== null && searchQuery.value !== '') {
        if (fecha.valido) {
          // eslint-disable-next-line
          listReturn = listLogs.value.filter(
            player =>
              // eslint-disable-next-line
              (player.nombre
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`) ||
              (player.valor
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`) ||
              (player.observacion
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`)
          )
        }
      }

      return listReturn
      // eslint-disable-next-line
    })
    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }
    onMounted(() => {
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos
      )
      const campActivo = listCampeonatos.value.find(
        // eslint-disable-next-line
        element => element.activo === 's'
      )
      campeonatoSeleccionado.value = campActivo
      getConfigPagos(campeonatoSeleccionado.value.value)
      getDetallePagos(campeonatoSeleccionado.value.value)
      getUtilsPagos(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      )
    })
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado']
    )
    watch(cambioTorneo, () => {
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos
      )
      // getListCategorias(data.id_torneo)
    })
    return {
      listCampeonatos,
      campeonatoSeleccionado,
      getConfigPagos,
      listCategorias,
      searchQuery,
      rangeDate,
      tableColumns,
      listPagosFilter,
      USER,
      ROLES,
      showLoading,
      crearPago,
      dataPagoSelected,
      recargar,
      listResponsables,
      totalPagar,
      pagado,
      saldo,
      openAuxiliar,
      listAuxiliarEquipos,
      nuevaConfig,
      recargarConfig,
      listCategoriasTodas,
      listFormasPago,
      dataPagoConfig,
      dataPagoConfigSelected,
      formaAuxiliar,
      deletePago,
      recargarDatos,
      openDetallePago,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
